<template>
  <div class="mt-8" v-if="shouldShowPromo">
    <vs-wrapper>
      <v-card class="mx-auto">
        <div class="new-feature-highlight">
          <div>🎉 New Feature!</div>

          <v-tooltip bottom>
            <template #activator="{ on }">
              <v-btn
                small
                color="white"
                data-test="formlayout-close"
                class="ma-0"
                icon
                v-on="on"
                @click="handleDismiss"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </template>

            Close
          </v-tooltip>
        </div>
        <v-card-text>
          <p class="text-h6 text--primary">Sync your batches to QuickBooks Online!</p>
          <div class="text--primary">
            Streamline your accounting and get paid faster by syncing your batches directly to
            QuickBooks Online. Setup is quick and easy.
            <a :href="knowledgeBase?.qbo" target="_blank" rel="noopener noreferrer"
              >Learn how it works</a
            >.
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn
            v-if="qboAppSetupDeepLink"
            text
            color="primary"
            target="_blank"
            rel="noopener"
            :href="qboAppSetupDeepLink"
          >
            Get Started
          </v-btn>
        </v-card-actions>
      </v-card>
    </vs-wrapper>
  </div>
</template>

<script setup lang="ts">
import { useLocalStorage } from '@vueuse/core'
import { computed } from 'vue'
import VsWrapper from '@/components/vision/VsWrapper.vue'
import { usePromotionQuery } from '@/components/batches/Promotion/usePromotionQuery'
import { useKnowledgeBaseQuery } from '@/api/composables/knowledge-base'

const emit = defineEmits<{
  (e: 'dismiss')
}>()

const handleDismiss = () => {
  emit('dismiss')
  dismissed.value = true
}

const { qboAppSetupDeepLink } = usePromotionQuery()
const { data: knowledgeBase } = useKnowledgeBaseQuery()

const dismissed = useLocalStorage('feature-promo:qbo-sync-dismissed', false)

const shouldShowPromo = computed(() => !dismissed.value)
</script>

<style scoped>
.new-feature-highlight {
  width: 100%;
  background: #328bff;
  color: white;
  padding: var(--space-small) var(--space-base);
  font-weight: bold;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
</style>
